import { Helmet } from 'react-helmet-async';

export default function About() {
  return (
    <div className="max-w-7xl mx-auto px-8 py-16">
      <Helmet>
        <title>About | BIOCAP Website</title>
        <meta name="description" content="Learn about BIOCAP's mission to revolutionize coastal infrastructure through innovative, environmentally conscious solutions." />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      
      <h1 className="text-4xl font-bold text-gray-900 mb-8">About BIOCAP</h1>
      <div className="grid md:grid-cols-2 gap-12">
        <div>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Our Mission</h2>
          <p className="text-gray-600 text-lg mb-6">
            BIOCAP is dedicated to revolutionizing coastal infrastructure through innovative,
            environmentally conscious solutions. We combine cutting-edge engineering with
            ecological preservation to create sustainable coastal protection systems.
          </p>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Our Vision</h2>
          <p className="text-gray-600 text-lg">
            We envision a future where coastal development and marine ecosystem preservation
            go hand in hand, creating resilient shorelines that benefit both human
            communities and marine life.
          </p>
        </div>
        <div>
          <img
            src="https://images.unsplash.com/photo-1507525428034-b723cf961d3e"
            alt="Coastal view"
            className="rounded-lg shadow-lg w-full h-full object-cover"
          />
        </div>
      </div>
    </div>
  );
} 